import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import moment from 'moment';
import { getQueryKeys } from '../../lib/getQueryKeys';
import useGetParamsForRequest from '../../hooks/useGetParamsForRequest';

const onDeparture = async (id) => {
  const body = moment().toISOString();

  return await request.put(
    `/Access/transport/${id}/departure`,
    body,
    'При изменение состояния пропуска произошла ошибка',
    'Error'
  );
};

const useDeparture = () => {
  const queryClient = useQueryClient();

  const paramsRequestPermits = useGetParamsForRequest();

  return useMutation(onDeparture, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryClient.refetchQueries(getQueryKeys.permits(paramsRequestPermits));
    },
  });
};

export default useDeparture;
